import styles from './email-container.module.scss';
import { Box, Container, Tab, Tabs } from '@frontend-workspace/react-shared-lib';
import { Col, Row } from 'reactstrap';
import { useState } from 'react';
import PageTitle from '../page-title/page-title';
import EmailList from '../email-list/email-list';
import EmailComponents from '../email-components/email-components';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface EmailContainerProps { }

export function EmailContainer(props: EmailContainerProps) {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState<number>(0);

  const navigateToTabOne = () => setSelectedTab(0);
  const navigateToTabTwo = () => setSelectedTab(1);

  return (
    <Container
      className="container-fluid pt-4 px-0"
      maxWidth={false}
      sx={{ paddingBottom: '50px' }}>
      <Row>
        <Col>
          <Box
            component="div"
            className="pb-5">
            <PageTitle title={t("standard.emails")} />
            <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: '20px' }}>
              <Tabs
                value={selectedTab}
                variant="scrollable"
                scrollButtons="auto">
                <Tab label={t("emailContainer.emailTemplates")} onClick={navigateToTabOne} />
                <Tab label={t("emailContainer.emailComponents")} onClick={navigateToTabTwo} />
              </Tabs>
            </Box>
            {selectedTab === 0 && <EmailList />}
            {selectedTab === 1 && <EmailComponents />}
          </Box>
        </Col>
      </Row>
    </Container>
  );
}

export default EmailContainer;